import { animate, AnimationTriggerMetadata, style, transition, trigger, state } from "@angular/animations";

const ANIMATION_DURATION = '300ms';
const TRANSITION = ANIMATION_DURATION + ' ease-in-out';

export const drawerAnimation: AnimationTriggerMetadata = trigger(
    'iccDrawerAnimation',
    [
        state('fadeIn',
            style({transform: 'translateX(0%)'})
        ),
        state('fadeOut',
            style({transform: 'translateX(-100%)'})
        ),
        transition(`fadeOut => fadeIn`, [
            animate(TRANSITION),
        ]),
        transition(`fadeIn => fadeOut`, [
            animate(TRANSITION),
        ]),
    ],
);
